/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const iconArrowUp = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.2534 0.355935C4.37271 0.183732 4.62729 0.183732 4.7466 0.355934L8.0709 5.15415C8.20875 5.35311 8.06635 5.625 7.8243 5.625H1.1757C0.933651 5.625 0.791255 5.35311 0.929099 5.15415L4.2534 0.355935Z"
      fill="#55C8AE"
    />
  </svg>
)

const ArrowUpIcon = (props) => <Icon component={iconArrowUp} {...props} />

export { ArrowUpIcon }
